const types = {};

types.GET_METRICS = 'GET_METRICS';

types.SET_CHART_DATA = 'SET_CHART_DATA';
types.RESET_CHART_DATA = 'RESET_CHART_DATA';
types.CHANGE_CHART_TYPE_VISIBILITY = 'CHANGE_CHART_TYPE_VISIBILITY';

export default types;



// WEBPACK FOOTER //
// ./src/screens/Metrics/store/types.js